<div class="controls">
    <div class="filter">
        <mat-form-field appearance="fill" class="search">
            <input
                #searchInput
                (keyup)="changeSearch()"
                [(ngModel)]="search"
                autocomplete="off"
                matInput
                placeholder="#"
                type="text" />
        </mat-form-field>
        @if (statuses) {
            <mat-form-field appearance="fill" class="status">
                <mat-select
                    (selectionChange)="changeLoadedStatuses()"
                    [(ngModel)]="statusIds"
                    [multiple]="true"
                    name="status"
                    placeholder="Statusen">
                    @for (status of statuses; track status) {
                        <mat-option [value]="status.id">
                            {{ status.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
    </div>
    <button (click)="newChat()" color="primary" mat-icon-button>
        <img src="/assets/images/icons/customer-projects/todo.svg" />
    </button>
</div>
<div class="chats">
    @if (chats?.length === 0) {
        @if (!isChatsManagement) {
            <div class="text-center my-5 col">
                Je hebt nog geen contact met ons opgenomen.
                <br /><br />
                Je kunt hier contact met ons opnemen als je een vraag, compliment of klacht hebt. Of als je meer
                informatie wilt over een project.
                <button (click)="newChat()" class="mt-3" mat-stroked-button>Direct contact opnemen</button>
                <br /><br />
                @if (projects) {
                    <div class="pt-2">
                        @if (projects?.length === 1) {
                            @if (projects[0].contacts?.length === 1) {
                                Wil je liever telefonisch contact? <br />
                                Neem contact op met<br />
                                {{ projects[0].contacts[0]?.name }}<br />
                                <a class="mt-2" mat-stroked-button href="tel:{{ projects[0].contacts[0]?.phone }}">
                                    Tel: {{ projects[0].contacts[0]?.phone }}
                                </a>
                            } @else {
                                @if (projects[0].contacts?.length > 1) {
                                    Wil je liever telefonisch contact? <br />
                                    Neem contact op met een van onze medewerkers<br />
                                    <button
                                        class="mt-2"
                                        mat-raised-button
                                        color="primary"
                                        routerLink="/{{ Routenames.customers }}/{{ projects[0].customer_id }}/{{
                                            Routenames.projects
                                        }}/{{ projects[0].id }}/{{ Routenames.contacts }}">
                                        Neem contact op
                                    </button>
                                }
                            }
                        } @else {
                            @if (projects?.length > 1) {
                                Wil je liever telefonisch contact? <br />
                                Neem contact op met een van onze medewerkers<br />
                                <button
                                    class="mt-2"
                                    mat-raised-button
                                    color="primary"
                                    routerLink="/{{ Routenames.customers }}/{{ projects[0].customer_id }}/{{
                                        Routenames.projects
                                    }}/{{ Routenames.contacts }}">
                                    Neem contact op
                                </button>
                            }
                        }
                    </div>
                }
            </div>
        } @else {
            <div class="text-center my-5">Er zijn geen meldingen gevonden</div>
        }
    }
    @for (chat of chats; track chat.id) {
        <div
            [routerLink]="['/', Routenames.chat, chat.id]"
            [class.active]="currentChat === chat"
            class="chat"
            matRipple>
            <div
                [class.unread]="
                    chat.lastMessage &&
                    chat?.lastMessage?.id !==
                        (chat.chat_users | byId: LocalStorage.getUser()?.id : 'user_id')?.last_read
                ">
                <div class="title">
                    @if (Utils.isToday(chat?.lastMessage?.updated_at)) {
                        <time class="time">{{ chat?.lastMessage?.updated_at | date: 'H:mm' }}</time>
                    } @else {
                        <time class="time d-none d-sm-block">
                            {{ chat?.lastMessage?.updated_at | date: 'd MMM yyyy H:mm' }}
                        </time>
                        <time class="time d-block d-sm-none">
                            {{ chat?.lastMessage?.updated_at | date: 'd MMM H:mm' }}
                        </time>
                    }
                    {{ chat.creator?.name }}
                </div>
                <div class="item">
                    <div class="message overflow-ellipsis">
                        @if (chat.lastMessage) {
                            <span>{{ chat.lastMessage?.user?.name }}: </span>
                        } @else {
                            <i>Nog geen berichten in deze chat</i>
                        }

                        @if (chat.lastMessage?.message | isBase64) {
                            <i class="fas fa-image"></i>
                        } @else {
                            {{ chat.lastMessage?.message }}
                        }
                    </div>
                    <div class="project-info">
                        <b>{{ chat.name | chatTypePipe }} #{{ chat.id }}</b>
                        &nbsp;-&nbsp;
                        <div class="name overflow-ellipsis">
                            {{ chat.customer_project?.name }}
                        </div>
                        <div class="status">
                            <span [style.color]="'#' + chat.status?.colorcode">{{ chat.status?.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    @if (!isChatsManagement && chats?.length > 0) {
        <div class="text-center col">
            <button (click)="newChat()" class="mt-3" mat-stroked-button>Nieuwe melding maken</button>
        </div>
    }
</div>
<ng-template #projectFilterSearchTemplate>
    <ng-select
        [(ngModel)]="searchProjects"
        (change)="changeSearch()"
        [closeOnSelect]="false"
        [hideSelected]="true"
        [items]="projects"
        [multiple]="true"
        bindLabel="name"
        bindValue="id"
        name="customers"
        placeholder="Filter Projecten"></ng-select>
</ng-template>
